import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { SgoModulo } from '../../models/sgo-modulo.model';
import { SgoSituacoesDemanda } from '../../models/sgo-situacoes-demanda';
import { NavigationService } from '../../services/navigation.service';
import { SgoSituacoesDemandaService } from '../../services/sgo-situacoes-demanda.service';

@Component({
  selector: 'app-sgo-situacoes-demanda-edit',
  templateUrl: './sgo-situacoes-demanda-edit.component.html',
  styleUrls: ['./sgo-situacoes-demanda-edit.component.scss']
})
export class SgoSituacoesDemandaEditComponent extends BaseFormComponent<SgoSituacoesDemanda> implements OnInit {

  actionLabel: string = 'Novo';
  sgoModulo: SgoModulo[];

  constructor(
    private myService: SgoSituacoesDemandaService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.sgoModulo = this.activatedRoute.snapshot.data['sgoModulo'];
    this.loaded();
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      keyword: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required]),
      sgo_module_id: new FormControl(1, [Validators.required]),
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
    }
  }

  voltar() {
    this.navigation.back(['projetos/admin-spgg/sgo-situacoes-demanda']);
  }

  getDataCreate(): SgoSituacoesDemanda {
    let data: SgoSituacoesDemanda;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res: SgoSituacoesDemanda) => {
              this.msgSuccess('Cadastro alterado com sucesso!');
              this.loaded();
            },
            error: (error) => {
              this.loaded();
              this.msgError();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: SgoSituacoesDemanda) => {
              this.msgSuccess('Cadastro criado com sucesso!');
              this.navigation.replace(['projetos/admin-spgg/sgo-situacoes-demanda/', res.id]);
              this.loaded();
            },
            error: (error) => {
              this.loaded();
              this.msgError();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }
}
